import { render } from "./WelcomeFirstAccessModal.vue?vue&type=template&id=4411c692&scoped=true"
import script from "./WelcomeFirstAccessModal.vue?vue&type=script&lang=js"
export * from "./WelcomeFirstAccessModal.vue?vue&type=script&lang=js"

import "./WelcomeFirstAccessModal.vue?vue&type=style&index=0&id=4411c692&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4411c692"]])

export default __exports__